import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useModule() {
  const api = useApi()
  const [dataModule, setData] = useState<SelectOptionType[]>([])
  const [isLoadingModule, setLoading] = useState(true)

  useEffect(() => {
    api.get("/module/?only_active=true")
    .then((res: SuccessFetch<{
      payload: {
        module_id: number
        module_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.module_name, value: item.module_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { dataModule, isLoadingModule }
}